import { IOrder } from '../types';

export interface ITransactionProps {
    orders: IOrder[];
    onLoadMore: any;
    hasMore: boolean;
    refresh: () => void;
    searchValue: string;
    onSearchChange: (value: string) => void;
    clearSearch: () => void;
}

export const trasactionFilterTypes = [
    {
        value: 'all',
        displayValue: 'All',
    },
    {
        value: 'pending',
        displayValue: 'Pending',
    },
    {
        value: 'completed',
        displayValue: 'Completed',
    },
    {
        value: 'failed',
        displayValue: 'Failed',
    },
];

export enum TabOptions {
    PENDING = 'Pending',
    COMPLETED = 'Completed',
}
